var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isCountrySupported)?_c('img',{attrs:{"src":_vm.flagImage,"alt":""}}):_vm._e(),_vm._v(" "+_vm._s(_vm.countryName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }